export default "__VITE_ASSET__Ct6k4Mnd__"